export const DEFAULT_ADDRESS_LIMIT = '40';
